{
  "version": "1.0.0",
  "data": {
    "source": "baostock",
    "symbol": "601360",
    "startDate": "2025-01-01",
    "endDate": "2026-05-17",
    "period": "daily",
    "adjust": "qfq"
  },
  "indicators": {
    "main": [
      {
        "type": "MA",
        "enabled": true,
        "params": {
          "periods": [
            5,
            10,
            20,
            60
          ]
        }
      },
      {
        "type": "BOLL",
        "enabled": true
      }
    ],
    "sub": [
      {
        "type": "MACD",
        "enabled": true
      },
      {
        "type": "RSI",
        "enabled": true
      }
    ]
  },
  "markers": {
    "customMarkers": [
      {
        "id": "event_001",
        "date": "2026-02-09",
        "shape": "arrow_up",
        "groupKey": "product_launch",
        "style": {
          "fillColor": "#52c41a"
        },
        "label": {
          "text": "AI语料概念大涨"
        },
        "metadata": {
          "reason": "主力资金净流入14.35亿元，AI语料概念板块领涨"
        }
      },
      {
        "id": "event_002",
        "date": "2026-02-10",
        "shape": "flag",
        "groupKey": "milestone",
        "style": {
          "fillColor": "#faad14"
        },
        "label": {
          "text": "股价创新高"
        },
        "metadata": {
          "reason": "股价突破13元，成交量放大"
        }
      },
      {
        "id": "event_003",
        "date": "2026-03-09",
        "shape": "arrow_up",
        "groupKey": "product_launch",
        "style": {
          "fillColor": "#52c41a"
        },
        "label": {
          "text": "龙虾智能体研发加速"
        },
        "metadata": {
          "reason": "周鸿祎透露一键安装版本研发中"
        }
      },
      {
        "id": "event_004",
        "date": "2026-03-10",
        "shape": "arrow_up",
        "groupKey": "product_launch",
        "style": {
          "fillColor": "#52c41a"
        },
        "label": {
          "text": "AI智能体应用推广"
        },
        "metadata": {
          "reason": "受AI智能体应用推广带动，股价上涨4.39%"
        }
      },
      {
        "id": "event_005",
        "date": "2026-03-11",
        "shape": "flag",
        "groupKey": "milestone",
        "style": {
          "fillColor": "#faad14"
        },
        "label": {
          "text": "业绩预盈公告"
        },
        "metadata": {
          "reason": "2025年净利润预计2.13-3.18亿元，同比扭亏为盈"
        }
      },
      {
        "id": "event_006",
        "date": "2026-03-13",
        "shape": "arrow_up",
        "groupKey": "product_launch",
        "style": {
          "fillColor": "#52c41a"
        },
        "label": {
          "text": "发布安全龙虾智能体"
        },
        "metadata": {
          "reason": "推出应用客户端、硬件终端及龙虾卫士，接入16家大模型"
        }
      },
      {
        "id": "event_007",
        "date": "2026-03-20",
        "shape": "flag",
        "groupKey": "milestone",
        "style": {
          "fillColor": "#faad14"
        },
        "label": {
          "text": "AI搜索安全创新"
        },
        "metadata": {
          "reason": "强化信源权威性管理，360智盾系统提升信息可靠性"
        }
      },
      {
        "id": "event_008",
        "date": "2026-03-22",
        "shape": "arrow_up",
        "groupKey": "security",
        "style": {
          "fillColor": "#1890ff"
        },
        "label": {
          "text": "独家发现OpenClaw漏洞"
        },
        "metadata": {
          "reason": "创始人确认360独家发现高危漏洞，展现安全实力"
        }
      },
      {
        "id": "event_009",
        "date": "2026-04-08",
        "shape": "arrow_up",
        "groupKey": "market",
        "style": {
          "fillColor": "#52c41a"
        },
        "label": {
          "text": "强势反弹"
        },
        "metadata": {
          "reason": "股价大涨7.09%，成交量显著放大"
        }
      }
    ]
  }
}